import { RequestProvider } from '@/shared/providers/request.provider';
import { APP_API } from '../values/app.values';
import { EduacProvider } from '../providers/eduac.provider';
import BrowserService from '@/providers/browser-utils/browser.service';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { AuthProvider } from '@/auth/providers/auth.provider';


class BackupFileServicesClass {

  private readonly BACKUP_CLIENT_IDENTIFIER = 'web';
  private readonly BACKUP_CLIENT_VERSION = '1.0';

  private timerForThrottling = null;
  private delay : number =  10000;

  get AuthStore() {
    return EduacProvider.prototype.$vue.$store.state.AuthStore
  }

  get AppStore() {
    return EduacProvider.prototype.$vue.$store.state.AppStore;
  }

  get AppServices() {
    return EduacProvider.prototype.$vue.$App.Store;
  }

  public async eduacCustomErrorHandler({promiseRejectionEvent = null, vueError = null, globalError = null, bugButtonEvent = null}) : Promise<any> {
    
    let errorType = undefined;
    let errorInfo = undefined;
  
    //any promise rejection
    if( promiseRejectionEvent ) {
      errorType = 'promise-rejection';
      //promiseRejectionEvent.reason.stack => when any code promise is rejected
      //promiseRejectionEvent.reason.data  => when a http request fails
      const stack = promiseRejectionEvent.reason?.stack;
      const data = promiseRejectionEvent.reason?.data;

    
      if ( stack ) {
        //promiseRejectionEvent.reason.(message, name, type) => when pdfjs throws errors 
        const message = promiseRejectionEvent.reason?.message;
        const name = promiseRejectionEvent.reason?.name;
        const type = promiseRejectionEvent.reason?.type;

        errorInfo = {
          stack,
          message, 
          name,
          type,
        }
      } else if( data ) {
        errorInfo = {
          ... data,
          url:promiseRejectionEvent.reason.config.url,
        };
      } else {
        errorInfo = promiseRejectionEvent;
      }
    }
  
    //vue errors
    if ( vueError ) {
      errorType = 'vue-error';
      errorInfo = `<${vueError.instance.$options._componentTag}> ` +  (vueError.error || vueError.info).toString();
    }
  
    //any error that is captured by window object
    if( globalError ) {
      errorType = 'global-error';
      errorInfo = globalError.error?.stack || globalError.msg;
    }

    //when user press the bug button
    if( bugButtonEvent ) {
      errorType = 'bug-button';
      errorInfo = bugButtonEvent.stack;
    }
  
    const location = window.location.href;
    const device = BrowserService.getFullBrowserInfo();

    const userPositionStored = this.AppStore.userPosition;
    let userPosition = {};
    for( let userPositionAttribute in userPositionStored ) {
      if( userPositionStored[userPositionAttribute] ) {
        userPosition[userPositionAttribute] = userPositionStored[userPositionAttribute];
      }
    }

    this.AppServices.addErrorLogs({errorType, location, device, userPosition, errorInfo});
    return this.saveLog();
  }


  public async sendUserInfoFromBugButton() : Promise<any> {
    return this.eduacCustomErrorHandler({bugButtonEvent:{stack:''}});
  }


  public async saveLog() : Promise<any> {

    const logs : any [] = this.AppStore.errorQueue;
    if( logs.length == 0 ) {
      return;
    }

    //----------- throttling starts --------------------------
    if( this.timerForThrottling != null) {
      return;
    } else {
      BackupFileServices.timerForThrottling = setTimeout(() => { 
        this.timerForThrottling = null;
        BackupFileServices.saveLog();
      }, BackupFileServices.delay);
    }
    //----------- throttling ends --------------------------*/

    const request = {
      client: this.BACKUP_CLIENT_IDENTIFIER,
      version: this.BACKUP_CLIENT_VERSION,
      username: this.AuthStore.user.userId,
      logMessage: JSON.stringify(logs),
    };

    let formData = new FormData();
    formData.append('externalData', JSON.stringify(request));
    try{
      const accessToken = LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);
      if( AuthProvider.getIsTokenActive(accessToken) ) {
        await RequestProvider.post(APP_API.BACKUP_DATA, formData, {}, { 'Content-Type': 'multipart/form-data' });
        this.AppServices.cleanErrorLogs();
      }
    } catch( error ) {
      //do not propagate this error to do not produce an infinite loop
      //console.log('BackupFileServicesClass.saveLog', error);
    }
    
    
  }

}

export const BackupFileServices = new BackupFileServicesClass();
